import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from '@ngrx/store';
import {ApplicationState} from '../../../application-state/store';
import {Observable} from 'rxjs';
import {Administrator} from '../../models';
import {AdministratorsSelectors} from '../../store/selectors';
import {loadIfNotLoaded} from '../../../shared/utilities/observable.utility';
import {AdministratorsActions} from '../../store';
import {OrdersSelectors} from '../../../orders/store/selectors';
import {Order} from '../../../orders/models';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-salesperson-select',
  styleUrls: ['./salesperson-select.component.scss'],
  template: `
    <div [formGroup]="formGroup">
      <ng-select
        [items]="items$|async"
        bindLabel="name"
        [searchable]="true"
        [loading]="isLoading$| async"
        bindValue="@id"
        [clearable]="true"
        [searchFn]="findItem"
        [placeholder]="'administrators.salesperson_select.placeholder' | translate"
        [formControlName]="fieldName"
        (change)="setSelectedItem($event)">

        <ng-template ng-label-tmp let-item="item">
          {{item.firstName}} {{item.lastName}}
          <span *ngIf="getOrderCount(item['@id'])>0">({{getOrderCount(item['@id'])}}x)</span>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          {{item.firstName}} {{item.lastName}}
          <span *ngIf="getOrderCount(item['@id'])>0">({{getOrderCount(item['@id'])}}x)</span>

        </ng-template>
      </ng-select>
    </div>
  `
})
export class SalespersonSelectComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() fieldName: string;
  @Output() updateSelectedObject: EventEmitter<Administrator> = new EventEmitter<Administrator>();

  items$: Observable<Array<Administrator>>;
  isLoading$: Observable<boolean>;
  selectedItem: Administrator;
  orders: Order[];

  constructor(private store$: Store<ApplicationState>) {
  }

  ngOnInit(): void {
    this.items$ = this.store$.select(AdministratorsSelectors.selectSalesMen);
    this.isLoading$ = this.store$.select(AdministratorsSelectors.isLoading);
    loadIfNotLoaded(this.store$, AdministratorsSelectors.isLoaded, AdministratorsActions.ReadAdministrators());
    this.store$.select(OrdersSelectors.sList).subscribe((orders) => {
      this.orders = orders;
    });

  }

  getOrderCount(adminIri: string): number {
    return this.orders.filter(e => e.salesperson["@id"] === adminIri).length || -1;
  }

  setSelectedItem(element: Administrator): void {
    this.selectedItem = element;
    this.updateSelectedObject.emit(element);
  }

  findItem(term: string, item: Administrator): boolean {
    const parts = term.split(' ');
    return parts.every(t => {
      return (item.firstName.toLowerCase().indexOf(t.toLowerCase()) > -1) ||
        (item.lastName && item.lastName.toLowerCase().indexOf(t.toLowerCase()) > -1) ||
        (item.middleName && item.middleName.toLowerCase().indexOf(t.toLowerCase()) > -1);
    });
  }


}
